var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVandewieleGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "lvibkpdxee-VANDEWIELE_-_Group",
    x: "0px",
    y: "0px",
    viewBox: "0 0 303.7 58.9",
    style: {
      enableBackground: "new 0 0 303.7 58.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.lvibkpdxee-st0{fill:#003382;}\r\n\t.lvibkpdxee-st1{enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M50.6,18.4l0.9,3.6l0.9-3.6L58.3,1H66L55.8,29.3h-9L36.6,1h8.1L50.6,18.4L50.6,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M82,24.5H71.7l-1.6,4.8h-7.7L72.5,1h9.1l10.2,28.3h-8.1L82,24.5L82,24.5z M73.7,18.7h6.4l-2.3-6.9l-0.9-3.3    L76,11.8L73.7,18.7L73.7,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M94.2,1h8l7.6,13.2l2.3,5L111.8,1h7.6v28.3h-8L103.8,16l-2.3-5l0.4,18.2h-7.6L94.2,1L94.2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M124,1h11.4c9,0,14.6,5.4,14.6,14.2s-5.6,14.1-14.6,14.1H124V1z M142.3,15.2c0-5.1-2.5-8-6.8-8h-3.8v16h3.8    C139.8,23.1,142.3,20.3,142.3,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M153.8,1h20.7v6h-13.1v5h11.4v5.8h-11.4v5.5h13.1v6h-20.7V1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M198.8,14.5l-0.7-3.3l-0.7,3.3l-4.1,14.8h-8.4L176.7,1h8.1l3.9,17.5l0.8,3.8l0.8-3.8l4.8-17.4h6.4l4.8,17.4    l0.9,3.8l0.8-3.8l3.9-17.4h7.7l-8.2,28.3H203L198.8,14.5L198.8,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M222.4,1h7.6v28.3h-7.6V1L222.4,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M234.6,1h20.7v6h-13.1v5h11.4v5.8h-11.4v5.5h13.1v6h-20.7V1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M259.2,1h7.6v22.2h11.8v6.2h-19.5L259.2,1L259.2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M281.8,1h20.7v6h-13.1v5h11.4v5.8h-11.4v5.5h13.1v6h-20.7V1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M1.2,18.1c1.6,5.2,5.5,9.4,10.6,11.1V0.9L1.2,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M29.5,12.1C28,6.9,24,2.7,18.9,1v28.4L29.5,12.1L29.5,12.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "lvibkpdxee-st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M44.2,51.8v-1.7h6.3v5.5c-1,0.8-2,1.4-3,1.7s-2.1,0.6-3.2,0.6c-1.5,0-2.8-0.3-4-0.9s-2.1-1.5-2.7-2.7    s-0.9-2.5-0.9-4s0.3-2.8,0.9-4.1c0.6-1.3,1.5-2.2,2.6-2.8c1.1-0.6,2.5-0.9,3.9-0.9c1.1,0,2.1,0.2,2.9,0.5c0.9,0.3,1.6,0.8,2,1.5    c0.5,0.6,0.9,1.4,1.1,2.4l-1.8,0.5c-0.2-0.8-0.5-1.4-0.8-1.8s-0.8-0.8-1.4-1c-0.6-0.3-1.3-0.4-2.1-0.4c-0.9,0-1.7,0.1-2.3,0.4    c-0.7,0.3-1.2,0.6-1.6,1.1s-0.7,0.9-0.9,1.5c-0.4,0.9-0.6,1.9-0.6,3c0,1.3,0.2,2.4,0.7,3.3s1.1,1.6,2,2s1.8,0.7,2.8,0.7    c0.9,0,1.7-0.2,2.5-0.5s1.4-0.7,1.9-1.1v-2.8H44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M54.3,57.6V42.7h6.6c1.3,0,2.3,0.1,3,0.4s1.2,0.7,1.7,1.4s0.6,1.4,0.6,2.2c0,1.1-0.3,1.9-1,2.7    c-0.7,0.7-1.7,1.2-3.2,1.4c0.5,0.2,0.9,0.5,1.2,0.7c0.6,0.5,1.1,1.2,1.6,2l2.6,4.1h-2.5l-2-3.1c-0.6-0.9-1.1-1.6-1.4-2.1    c-0.4-0.5-0.7-0.8-1-1s-0.6-0.3-0.9-0.4c-0.2,0-0.6-0.1-1.1-0.1h-2.3v6.7H54.3z M56.3,49.3h4.2c0.9,0,1.6-0.1,2.1-0.3    s0.9-0.5,1.2-0.9s0.4-0.9,0.4-1.3c0-0.7-0.3-1.3-0.8-1.7s-1.3-0.7-2.4-0.7h-4.7C56.3,44.4,56.3,49.3,56.3,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M69.5,50.4c0-2.5,0.7-4.4,2-5.8s3-2.1,5.1-2.1c1.4,0,2.6,0.3,3.7,1s1.9,1.6,2.5,2.8c0.6,1.2,0.9,2.5,0.9,4    s-0.3,2.9-0.9,4.1s-1.5,2.1-2.6,2.7S77.9,58,76.6,58c-1.4,0-2.7-0.3-3.8-1c-1.1-0.7-1.9-1.6-2.5-2.8    C69.8,52.9,69.5,51.7,69.5,50.4z M71.6,50.4c0,1.8,0.5,3.2,1.4,4.2c1,1,2.2,1.5,3.6,1.5c1.5,0,2.7-0.5,3.7-1.6s1.4-2.5,1.4-4.4    c0-1.2-0.2-2.3-0.6-3.2c-0.4-0.9-1-1.6-1.8-2.1s-1.7-0.7-2.7-0.7c-1.4,0-2.6,0.5-3.6,1.4S71.6,48.1,71.6,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M96.9,42.7h2v8.6c0,1.5-0.2,2.7-0.5,3.6s-1,1.6-1.8,2.2c-0.9,0.6-2,0.8-3.5,0.8c-1.4,0-2.5-0.2-3.4-0.7    s-1.5-1.2-1.9-2.1s-0.6-2.2-0.6-3.7v-8.6h2v8.6c0,1.3,0.1,2.2,0.4,2.9s0.7,1.1,1.2,1.4c0.6,0.3,1.3,0.5,2.2,0.5    c1.5,0,2.5-0.3,3.1-1s0.9-1.9,0.9-3.8L96.9,42.7L96.9,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lvibkpdxee-st0",
    d: "M103,57.6V42.7h5.6c1,0,1.7,0,2.3,0.1c0.7,0.1,1.3,0.4,1.8,0.7c0.5,0.3,0.9,0.8,1.2,1.4s0.5,1.3,0.5,2    c0,1.3-0.4,2.3-1.2,3.2c-0.8,0.9-2.3,1.3-4.4,1.3H105v6.2H103z M105,49.8h3.9c1.3,0,2.2-0.2,2.7-0.7s0.8-1.1,0.8-2    c0-0.6-0.2-1.2-0.5-1.6s-0.7-0.7-1.2-0.9c-0.3-0.1-0.9-0.1-1.8-0.1h-3.8L105,49.8L105,49.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVandewieleGroup);
export default __webpack_public_path__ + "static/media/logo-vandewiele-group.a15369a87ef6ac92972090dd7d81c769.svg";
export { ForwardRef as ReactComponent };